import { DocumentPagesPayload } from '../../../types/main';
import { DocumentPage, Media, DocumentDownloadUrl } from './types';

export const transformDocumentPage = (payload: DocumentPagesPayload): DocumentPage[] => {
  const fullPages = payload.full_pages[0];
  const thumbnails = payload.thumbnails[0];
  const pages: DocumentPage[] = [];
  const truncateFilename = (url: string) => {
    const split = url.split('/');
    return split[split.length - 1].split('?')[0];
  };

  fullPages.forEach((item, key) => {
    pages.push({
      id: item.page,
      url: item.url,
      filename: truncateFilename(item.url.url),
      thumbnails: thumbnails[key].thumbnails.map((thumb) => {
        return {
          width: thumb.width,
          height: thumb.height,
          signed_url: thumb.url,
          filename: truncateFilename(item.url.url),
        };
      }),
    });
  });

  return pages;
};

export const setDocumentDownloadUrl = (state: Media[], payload: DocumentDownloadUrl) => {
  const mediaIndex = state.findIndex((item) => item.id === payload.documentId);
  if (mediaIndex !== -1) {
    state[mediaIndex].url = payload.signedUrl.url;
    return [...state];
  }

  return state;
};
